module.exports = __webpack_public_path__ + "static/media/exampleVideo.bc434fe4.mp4";